<div class="flex flex-row">
	<slot></slot>
    <div class="flex-grow border-b border-gray-200"></div>
</div>
